export const FETCH_INDIVIDUAL_PRODUCT_REQUEST =
  "FETCH_INDIVIDUAL_PRODUCT_REQUEST";
export const FETCH_INDIVIDUAL_PRODUCT_SUCCESS =
  "FETCH_INDIVIDUAL_PRODUCT_SUCCESS";
export const FETCH_INDIVIDUAL_PRODUCT_FAILED =
  "FETCH_INDIVIDUAL_PRODUCT_FAILED ";
